import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@noor/ui';
import { rejectRequestSchema } from '../model/schema';

interface RejectReasonDialogProps {
  open: boolean;
  pending: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

/** Reject requires a reason (API contract) — collected in a nested dialog. */
export function RejectReasonDialog({
  open,
  pending,
  onClose,
  onConfirm,
}: RejectReasonDialogProps) {
  const { t } = useTranslation('moderation');
  const [reason, setReason] = useState('');
  const valid = rejectRequestSchema.safeParse({ reason }).success;

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('reject.title', 'Отклонить изменение?')}</DialogTitle>
          <DialogDescription>
            {t('reject.description', 'Укажите мерчанту, что нужно исправить.')}
          </DialogDescription>
        </DialogHeader>
        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={t('reject.reasonPlaceholder', 'Причина отклонения…')}
          rows={4}
          maxLength={500}
          aria-label={t('reject.reasonPlaceholder', 'Причина отклонения…')}
        />
        <DialogFooter>
          <Button
            type="button"
            variant="soft"
            shape="rounded"
            size="modal"
            onClick={onClose}
            disabled={pending}
          >
            {t('common:action.cancel', 'Cancel')}
          </Button>
          <Button
            type="button"
            variant="destructive"
            shape="rounded"
            size="modal"
            onClick={() => {
              if (!valid || pending) return;
              onConfirm(reason.trim());
              setReason('');
            }}
            disabled={!valid || pending}
          >
            {t('reject.confirm', 'Отклонить')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
